import { Link } from 'react-router-dom';
import { Input, List, Typography } from 'antd';
import { RightOutlined, SearchOutlined } from '@ant-design/icons';

import JoinOrganization from '../../components/JoinOrganization';

import BRIEFCASE from '../../img/pages/organization/briefcase.svg';
import ORGANIZATION1 from '../../img/pages/organization/organization1.svg';
import ORGANIZATION2 from '../../img/pages/organization/organization2.svg';
import ORGANIZATION3 from '../../img/pages/organization/organization3.svg';
import ORGANIZATION4 from '../../img/pages/organization/organization4.svg';
import LOGO from '../../img/logo.svg';

import styles from './switch.module.scss';
import { useState } from 'react';

const Header = () => {
  return (
    <div className={styles.app__header}>
      <Link to="/">
        <img src={LOGO} alt="logo" />
      </Link>
    </div>
  );
};

const items = [
  {
    image: ORGANIZATION1,
    name: '[Organization Name]',
    members: 2,
    current: true,
  },
  {
    image: ORGANIZATION2,
    name: '[Organization Name]',
    members: 12,
  },
  {
    image: ORGANIZATION3,
    name: '[Organization Name]',
    members: 4,
  },
  {
    image: ORGANIZATION4,
    name: '[Organization Name]',
    members: 7,
  },
];

const SwitchOrganization = () => {
  const [invite, setInvite] = useState(false);

  return (
    <div className={styles.app}>
      <Header />
      <div className={styles.app__organization}>
        <div className={styles.app__organization__body}>
          <div className={styles.app__organization__body__welcome}>
            <img
              src={BRIEFCASE}
              alt="briefcase"
              className={styles.app__organization__body__welcome__image}
            />
            <div className={styles.app__organization__body__welcome__title}>
              Switch Organization
            </div>
            <div className={styles.app__organization__body__welcome__text}>
              Here are all of the organizations that you have been invited to and those that you
              have already joined.
            </div>
          </div>
          {invite && (
            <>
              <Typography.Title className={styles.app__title}>Pending Invite</Typography.Title>
              <JoinOrganization name="[Organization Name]" members={2} expires={2} />
            </>
          )}
          <Typography.Title className={styles.app__title}>Companies Joined</Typography.Title>
          {!invite && (
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              size="large"
              className={styles.app__search}
            />
          )}
          <List
            dataSource={items}
            renderItem={(item) => (
              <List.Item className={styles.app__list}>
                <div style={{ display: 'flex' }}>
                  <img src={item.image} alt="organization" className={styles.app__list__image} />
                  <div>
                    <div className={styles.app__list__name}>{item.name}</div>
                    <div className={styles.app__list__members}>{item.members} members</div>
                  </div>
                </div>
                <div>
                  {item.current ? (
                    <div className={styles.app__list__current}>Current</div>
                  ) : (
                    <RightOutlined />
                  )}
                </div>
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default SwitchOrganization;
